export default "__VITE_ASSET__bb111ddc__"